module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-brands-ZJWE2ELA.eot?a6db396393f1097f0bfb77877e275c87";